module.exports = __webpack_public_path__ + "img/fsus.6c1bc2d0.JPG";